module.exports = __webpack_public_path__ + "img/created-img.b1f72b4e.svg";